import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { renderChildren } from './util';
import { emptyFn } from '../../utils/helper';
import Checkbox from './Checkbox';
import { consumeTheme } from '../../utils/theme';
var Group = (function (_super) {
    __extends(Group, _super);
    function Group() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            values: _this.props.defaultValues || []
        };
        _this.handleSingleChange = function (checked, e) {
            if (_this.props.disabled) {
                return;
            }
            var checkedValues = _this.state.values;
            var newValues = [];
            if (checkedValues.indexOf(e.target.value) >= 0 && !checked) {
                newValues = checkedValues.filter(function (v) { return v !== e.target.value; });
                _this.setState({ values: newValues });
                _this.props.onChange(newValues, e);
            }
            else if (checkedValues.indexOf(e.target.value) === -1 && checked) {
                newValues = checkedValues.concat(e.target.value);
                _this.setState({ values: newValues });
                _this.props.onChange(newValues, e);
            }
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, itemStyle = _a.itemStyle;
            var classes = classNames(prefixCls, className);
            return (h("div", { className: classes, style: style }, renderChildren(_this.props, _this.state.values, _this.handleSingleChange, Checkbox, itemStyle)));
        };
        return _this;
    }
    Group.getDerivedStateFromProps = function (props, state) {
        if ('values' in props) {
            return { values: props.values };
        }
        return null;
    };
    Group.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Group;
}(React.Component));
export default Group;
Group.defaultProps = {
    prefixCls: 'dui-m-checkbox-group',
    disabled: false,
    onChange: emptyFn
};
Group.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    options: PropTypes.array,
    disabled: PropTypes.bool,
    values: PropTypes.array,
    children: PropTypes.node,
    defaultValues: PropTypes.array,
    onChange: PropTypes.func,
    itemStyle: PropTypes.object
};
